<template>
  <v-dialog id="type-help-dialog" persistent max-width="1400" v-model="dialog" class="text-center"
            overlay-color="black">
    <v-progress-circular
        indeterminate
        color="white"
        class="loader"
        v-if="loading"
    ></v-progress-circular>
    <div id="iframe-container">
      <v-btn fab color="#ED217C" class="close-button" @click="close">
        <v-icon dark class="white--text">
          mdi-close
        </v-icon>
      </v-btn>
      <iframe
          :src="src"
          height="800"
          width="500"
          class="mx-auto"
          @load="loading=false"
          @loadstart="loading=true"
      />
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "TypeHelpDialog",
  props: {
    value: { type: Boolean },
    src: { type: String, required: true }
  },
  data() {
    return {
      loading: true,
    };
  },
  computed: {
    dialog: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
  methods: {
    close() {
      this.loading = true;
      this.$emit("close");
    }
  }
};
</script>

<style scoped lang="scss">
.loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}

.type-help-dialog {
  position: relative;
}

#iframe-container {
  position: relative;
  width: 100%;
}

iframe {
  width: 100%;
}

.close-button {
  position: absolute;
  top: 20px;
  right: 20px;
}
</style>
